function passcodeValidator({ configs, input, msgs }) {
  const {
    CUSTOMER_PASSWORD_FORBIDDEN_CHARS,
    allnumeric,
    alphanumeric,
    forbidchars,
    maxlength,
    minlength,
    mixedcase,
    restrictspace,
    specialchars,
  } = configs;

  let isMixedCase = false;
  let isAlpha = false;
  let isSpecial = false;
  let isForbid = false;
  let isRes = false;
  let isNum = false;
  let minl = false;
  let maxl = false;

  // Mixed Case Validation (Upper and Lower case)
  if (mixedcase === 'true') {
    const mixedCaseRegex = /^(?=.*[a-z])(?=.*[A-Z])/;
    isMixedCase = !mixedCaseRegex.test(input);
  }

  // Alphanumeric (At least one letter and one digit)
  if (alphanumeric === 'true') {
    const alphanumericRegex = /^(?=.*[a-zA-Z])(?=.*\d)/; // Corrected regex
    isAlpha = !alphanumericRegex.test(input);
  }

  // Special Characters
  if (specialchars === 'true') {
    const specialCharsRegex = /[@#$%^&+=]/; // Validates for special characters
    isSpecial = !specialCharsRegex.test(input);
  }

  // Check for Forbidden Characters
  if (forbidchars === 'true') {
    const forbiddenCharsRegex = new RegExp(`[${CUSTOMER_PASSWORD_FORBIDDEN_CHARS}]`);
    isForbid = forbiddenCharsRegex.test(input);
  }

  if (restrictspace === 'true') {
    const spaceRegex = /\s/;
    isRes = spaceRegex.test(input);
  }

  // Check Minimum Length
  if (minlength) {
    minl = input.length < parseInt(minlength);
  }

  // Check Maximum Length
  if (maxlength) {
    maxl = input.length > parseInt(maxlength);
  }

  // All Numbers Check
  if (allnumeric === 'true') {
    const allNumbersRegex = /^\d+$/;
    isNum = !allNumbersRegex.test(input);
  }

  // Combined Conditions and Return Messages

  if (isAlpha && isSpecial && isForbid && isRes)
    return msgs.customer_alphanumeric_specialchars_forbidchars_restrictspace;

  if (isMixedCase && isAlpha && isSpecial && isForbid && isRes)
    return msgs.customer_mixedcase_alphanumeric_specialchars_forbidchars_restrictspace;

  if (isMixedCase && isAlpha && isSpecial && isForbid)
    return msgs.customer_mixedcase_alphanumeric_specialchars_forbidchars;

  if (isMixedCase && isAlpha && isSpecial && isRes)
    return msgs.customer_mixedcase_alphanumeric_specialchars_restrictspace;

  if (isMixedCase && isAlpha && isForbid && isRes)
    return msgs.customer_mixedcase_alphanumeric_forbidchars_restrictspace;

  if (isMixedCase && isSpecial && isForbid && isRes)
    return msgs.customer_mixedcase_specialchars_forbidchars_restrictspace;

  if (isMixedCase && isAlpha && isSpecial) return msgs.customer_mixedcase_alphanumeric_specialchars;

  if (isMixedCase && isAlpha && isForbid) return msgs.customer_mixedcase_alphanumeric_forbidchars;

  if (isMixedCase && isSpecial && isForbid) return msgs.customer_mixedcase_specialchars_forbidchars;

  if (isMixedCase && isAlpha && isRes) return msgs.customer_mixedcase_alphanumeric_restrictspace;

  if (isMixedCase && isSpecial && isRes) return msgs.customer_mixedcase_specialchars_restrictspace;

  if (isMixedCase && isForbid && isRes) return msgs.customer_mixedcase_forbidchars_restrictspace;

  if (isMixedCase && isAlpha) return msgs.customer_mixedcase_alphanumeric;

  if (isMixedCase && isSpecial) return msgs.customer_mixedcase_specialchars;

  if (isMixedCase && isForbid) return msgs.customer_mixedcase_forbidchars;

  if (isMixedCase && isRes) return msgs.customer_mixedcase_restrictspace;

  if (isAlpha && isSpecial && isForbid && isRes)
    return msgs.customer_alphanumeric_specialchars_forbidchars_restrictspace;

  if (isAlpha && isSpecial && isForbid) return msgs.customer_alphanumeric_specialchars_forbidchars;

  if (isAlpha && isSpecial && isRes) return msgs.customer_alphanumeric_specialchars_restrictspace;

  if (isAlpha && isForbid && isRes) return msgs.customer_alphanumeric_forbidchars_restrictspace;

  if (isSpecial && isForbid && isRes) return msgs.customer_specialchars_forbidchars_restrictspace;

  if (isAlpha) return msgs.customer_alphanumeric;

  if (isMixedCase) return msgs.customer_mixedcase;

  if (isSpecial) return msgs.customer_specialchars;

  if (isForbid) return msgs.customer_forbidchars;

  if (isRes) return msgs.customer_restrictspace;

  if (isNum) return msgs.customer_allnumeric;

  if (minl) return msgs.min_length;

  if (maxl) return msgs.max_length;

  return null; // Return null if no validation fails
}

export default passcodeValidator;
